// src/components/navItems.js
//
// The primary navigation, shared by the desktop bar and the phone drawer in
// PageLayout. `match` lists the route prefixes a link stands for, so the link
// is lit on every screen under it (Jobs while editing a job, Companies while
// editing a contact) and not only on the list it opens. `tour` is the link's
// step in the first sign-in walkthrough (walkthrough/steps.js), which reads
// who sees it from `editorsOnly` here rather than saying so a second time.

export const NAV_ITEMS = [
  { label: "Home", to: "/", match: ["/"] },
  {
    label: "Jobs",
    tour: "jobs",
    to: "/JobsList",
    match: ["/JobsList", "/CreateJob", "/EditJob"],
  },
  {
    label: "Companies",
    tour: "companies",
    to: "/CompanySearch",
    match: [
      "/CompanySearch",
      "/CompaniesList",
      "/CreateCompany",
      "/EditCompany",
      "/CreateContact",
      "/EditContact",
      "/CreateLocation",
      "/EditLocation",
    ],
  },
  {
    label: "Warehouse",
    tour: "warehouse",
    to: "/WarehouseInventory",
    editorsOnly: true,
    match: [
      "/WarehouseInventory",
      "/TagList",
      "/TagListCompany",
      "/PrintTags",
      "/ViewBOLs",
      "/CreateBOL",
      "/EditBOL",
      "/PrintBOLTemplate",
    ],
  },
  {
    label: "Storage Billing",
    tour: "storage-billing",
    to: "/PrintStorageBilling",
    match: ["/PrintStorageBilling"],
  },
];

/* Home is lit on "/" alone; every other link on its prefixes, as a whole path
   segment, so "/TagList/W-1001" lights Warehouse and "/TagListCompany/4001"
   does not light it by way of "/TagList". */
export function isCurrentNav(item, pathname) {
  return item.match.some((prefix) =>
    prefix === "/"
      ? pathname === "/"
      : pathname === prefix || pathname.startsWith(prefix + "/"),
  );
}
